import Switch from '@components/v2/form/Switch/Switch';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { GeneralSettingsFormTestIds } from '../../../../utils/testIds/GeneralSettingsForm.testIds';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { ConnectionsSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const ConnectionsSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: ConnectionsSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_CONNECTIONS_TITLE)}
      description={LangEnum.GENERAL_SETTINGS_CONNECTIONS_DESCRIPTION}
    >
      <Stack sx={{ gap: 2 }}>
        <Switch
          label={translate(
            LangEnum.GENERAL_SETTINGS_AUTO_ACCEPT_INVITE_FROM_CUSTOMER_WITH_REPRESENTATIVE,
          )}
          name="autoAcceptInviteFromCustomerWithRepresentative"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.autoAcceptInviteFromCustomerWithRepresentative}
          testId="switch_general_settings_auto_accept_invite_from_customer_with_representative"
          onChange={(_, checked) =>
            handleChangeAndBlur({
              value: checked,
              name: 'autoAcceptInviteFromCustomerWithRepresentative',
            })
          }
        />
        <Switch
          label={translate(LangEnum.GENERAL_SETTINGS_ALLOW_REPRESENTATIVES_TO_INVITE_CUSTOMERS)}
          name="allowRepresentativesToInviteCustomers"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.allowRepresentativesToInviteCustomers}
          testId={GeneralSettingsFormTestIds.ALLOW_REPRESENTATIVES_TO_INVITE_CUSTOMERS_SWITCH}
          onChange={(_, checked) =>
            handleChangeAndBlur({ value: checked, name: 'allowRepresentativesToInviteCustomers' })
          }
        />
      </Stack>
    </SettingContainer>
  );
};

export default ConnectionsSectionGeneralSettings;
